import React from 'react';


export const ReplaceParameterValues = (title, data) => {
  if (!data) return title;
  else {
    title.match(/[^{\}]+(?=})/g).map(param => {
      if (data[param]) {
        title = title.replace(`{${param}}`, data[param]);
      }
    });
  
    return title;
  }
}

export const FormatUrlParams = (baseUrl, params) => {
  let url = baseUrl + '?';
  
  Object.keys(params).forEach((param, i) => {
    url += param + '=' + params[param];
    
    if (i < Object.keys(params).length - 1) {
      url += '&';
    };
  });

  return url;
}

const formatInputType = field => {
  let inputData = {};

  switch (field.fieldType) {
    case 'string':
      inputData = { component: 'input', type: 'text', maxLength: field.fieldLength };
      break;
      
    case 'int':
      inputData = { component: 'select', type: 'select', children: field.fieldListItems };
      break;
      
    case 'decimal':
      inputData = { component: 'input', type: 'number', max: field.fieldLength };
      break;
      
    case 'date':
      inputData = { component: 'input', type: 'date' };
      break;
      
    case 'bool':
      inputData = { component: 'input', type: 'checkbox', label: field.fieldLabel };
      break;
      
    default:
      inputData = { component: 'input', type: 'text' };
      break;
  }

  return inputData;
}

export const FormatBookingFields = fields => {
  let data = {};

  // Create form from Custom Booking Fields
  fields.map(f => {
    data[f.fieldName] = {
      // Determine type of HTML DOM Element
      ...formatInputType(f),
      placeholder: f.fieldLabel,
      required: f.fieldRequired
    }
  })

  return data;
}

export const InitializeFields = (element, fieldName, fieldType, onschedState, resource) => {
  let defaultValue = '';
  let display = "true";

  if (element.options.fields) {
    if (element.options.fields[fieldName]) {
      if (typeof element.options.fields[fieldName] === (fieldType ? fieldType : "string")) {
        defaultValue = element.options.fields[fieldName];
      }
    }
    else if (element.options.fields[fieldName] === false) {
      display = "false";
    }
    else if (onschedState?.state?.[resource]?.[fieldName]) {
      defaultValue = onschedState?.state?.[resource]?.[fieldName];
    }
  }
  else if (onschedState?.state?.[resource]?.[fieldName]) {
    defaultValue = onschedState?.state?.[resource]?.[fieldName];
  }
  
  return { defaultValue, display }
}

export const UpdateOnSchedAvailabilityCalendarColorScheme = () => {
  const calendarDates = document.querySelectorAll('.qs-square.qs-num');

  if (calendarDates) {
    calendarDates.forEach(elDate => {
      if (!elDate.classList.contains('onsched-secondary-background-color-hover-child')) {
        elDate.classList.add('onsched-secondary-background-color-hover-child')
      }
      if (elDate.classList.contains('qs-active')) {
        elDate.innerHTML = `<span class="CalendarDate onsched-secondary-background-color onsched-primary-color">${elDate.innerText}</span>`;
      }
      else if (elDate.classList.contains('qs-current')) {
        elDate.innerHTML = `<span class="CalendarDate onsched-primary-color onsched-secondary-background-color-hover">${elDate.innerText}</span>`;
      }
      else {
        elDate.innerHTML = `<span class="CalendarDate onsched-secondary-background-color-hover">${elDate.innerText}</span>`;
      }
    })
  }
}

export const ReformatAPIPayload = (element) => ({
  ServiceSetup: ({ values, state }) => new Promise((resolve, reject) => {
    const weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    
    let data = { availability: {} };

    weekdays.map(w => {
      const morningStart = values[`availability.${w}.startTimeMeridiem`] === 'am';
      const morningEnd = values[`availability.${w}.endTimeMeridiem`] === 'am';

      const start = values[`availability.${w}.startTime`];
      const end = values[`availability.${w}.endTime`];

      if (start && end) {
        data.availability[w] = { 
          startTime: morningStart ? parseInt(start) : parseInt(start) + 1200,
          endTime: morningEnd ? parseInt(end) : parseInt(end) + 1200
        }
      }
    })
    
    const convertMerid = (day, time) =>
      values[`availability.${day}.${time}TimeMeridiem`] === `am` ? parseInt(values[`availability.${day}.${time}Time`]) : parseInt(values[`availability.${day}.${time}Time`]) + 1200;

    data.timezoneName = values.timezone;
    data.duration = values.duration;
    data.name = values.name;
    data.email = values.email ? values.email : '';
    data.website = values.website ? values.website : '';
    data.blocks = state.blocks;
    data.availability = {
      mon: {
        startTime: convertMerid('mon', 'start') ? convertMerid('mon', 'start') : 0,
        endTime: convertMerid('mon', 'end') ? convertMerid('mon', 'end') : 0,
      },
      tue: {
        startTime: convertMerid('tue', 'start') ? convertMerid('tue', 'start') : 0,
        endTime: convertMerid('tue', 'end') ? convertMerid('tue', 'end') : 0,
      },
      wed: {
        startTime: convertMerid('wed', 'start') ? convertMerid('wed', 'start') : 0,
        endTime: convertMerid('wed', 'end') ? convertMerid('wed', 'end') : 0,
      },
      thu: {
        startTime: convertMerid('thu', 'start') ? convertMerid('thu', 'start') : 0,
        endTime: convertMerid('thu', 'end') ? convertMerid('thu', 'end') : 0,
      },
      fri: {
        startTime: convertMerid('fri', 'start') ? convertMerid('fri', 'start') : 0,
        endTime: convertMerid('fri', 'end') ? convertMerid('fri', 'end') : 0,
      },
      sat: {
        startTime: convertMerid('sat', 'start') ? convertMerid('sat', 'start') : 0,
        endTime: convertMerid('sat', 'end') ? convertMerid('sat', 'end') : 0,
      },
      sun: {
        startTime: convertMerid('sun', 'start') ? convertMerid('sun', 'start') : 0,
        endTime: convertMerid('sun', 'end') ? convertMerid('sun', 'end') : 0,
      },
    }
    data.address = {
      addressLine1: values.addressLine1 ? values.addressLine1 : '',
      addressLine2: values.addressLine2 ? values.addressLine2 : '',
      city: values.city ? values.city : '',
      state: values.state ? values.state : '',
      postalCode: values.postalCode ? values.postalCode : '',
    }

    resolve(data);
  })
})

export const FormatQueryParams = paramsObject => {
  return '?' + new URLSearchParams(paramsObject).toString()
}

export const FormatApptPayload = (element, appointment) => {
  const { 
    startDateTime,
    endDateTime,
    serviceId,
    travelAppointmentId,
    travelTimeMins 
  } = appointment;

  let payload = { 
    startDateTime,
    endDateTime,
    serviceId,
    travelAppointmentId,
    travelTimeMins 
  };

  if (appointment.customerId) {
    payload.customerId = appointment.customerId;
  }

  // Round Robin
  if (element.params.roundRobin) {
    // YES
    payload.resourceId = appointment.resourceId;
  }
  else {
    // Multiple Resources
    if (element.params.resourceIds) {
      // YES
      payload.resourceIds = params.resourceIds;
    }
    else {
      // NO
      payload.resourceId = appointment.resourceId;
    }
  }

  if (!payload.customerId) {
    if (element.options.customerId) {
      payload.customerId = element.options.customerId;
    }
    else {
      payload = Object.assign(payload, FormatCustomerAppointmentPayload(element));
    }
  }

  return payload;
}

export const FormatCustomerNotificationType = (element, customer) => {
  const { options } = element;

  let data = { notificationType: customer.notificationType };
  
  data.id = customer.id;

  // If Notification Type is None or Email
  if (options.customerSMS) {
    if (customer.notificationType === "0") {
      // Update to SMS
      data.notificationType = "2";
    }
    else if (customer.notificationType === "1") {
      // Update to Email & SMS
      data.notificationType = "3";
    }
    // Add phone number if none is stored
    if (!customer.contact.mobilePhone?.length) {
      if (options.fields?.phone) {
        data.contact = { phoneType: 'm', mobilePhone: options.fields.phone };
      }
    }
  }


  return data;
}

export const FormatCustomerAppointmentPayload = (element) => {
  const { options } = element;

  let data = {};

  if (options.fields) {
    data = options.fields;

    if (data.firstName && data.lastName) {
      data.name = data.firstName + ' ' + data.lastName;
      delete data.firstName;
      delete data.lastName;
    }
  }

  return data;
};